import React, { useEffect, useState, useRef } from "react";
import {
  FaSignOutAlt,
  FaBars,
  FaUserCircle,
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaEye,
  FaCheck,
  FaCertificate,
  FaDownload,
  FaSearch,
} from "react-icons/fa";
import {
  MdBadge,
  MdCategory,
  MdDashboard,
  MdEdit,
  MdEvent,
  MdGrade,
  MdGroup,
  MdImage,
  MdLink,
  MdPhotoLibrary,
  MdPostAdd,
  MdStar,
  MdStore,
  MdTv,
  MdVerified,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  FacebookEmbed,
  InstagramEmbed,
  YouTubeEmbed,
} from "react-social-media-embed"

const API = "https://api.garudasena.org";


const Info = ({ label, value }) => (
  <div
    style={{
      background: "#fff",
      border: "1px solid #eee",
      borderRadius: 8,
      padding: "10px 12px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    }}
  >
    <strong style={{ color: "var(--primary)" }}>{label}:</strong>
    <div style={{ marginTop: 4, color: "#555" }}>{value}</div>
  </div>
);

const spinnerStyle = {
  width: "14px",
  height: "14px",
  border: "2px solid #fff",
  borderTop: "2px solid transparent",
  borderRadius: "50%",
  display: "inline-block",
  animation: "spin 0.7s linear infinite",
};

// Keyframes injected inline
const spinKeyframes = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;



const AdminDashboard = () => {
  const adminEmail = sessionStorage.getItem("adminEmail");
  const navigate = useNavigate();

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeComponent, setActiveComponent] = useState(
    localStorage.getItem("activeComponent") || "Dashboard"
  );
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  const [images, setImages] = useState([]); // State for storing uploaded images

const [approvingId, setApprovingId] = useState(null);

  
 const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);
  const [showModalV, setShowModalV] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");


  // Pagination
  const [currentPageV, setCurrentPageV] = useState(1);
  const itemsPerPageV = 20;
  // const totalPagesV = Math.ceil(volunteers.length / itemsPerPageV);


  const filteredVolunteers = volunteers.filter(v => {
  const term = searchTerm.toLowerCase();
  
  return (
    v.name?.toLowerCase().includes(term) ||
    v.email?.toLowerCase().includes(term) ||
    v.mobile?.toLowerCase().includes(term) ||
    v.city?.toLowerCase().includes(term) ||
    v.registration_no?.toLowerCase().includes(term) ||
    v.aadhar_number?.toLowerCase().includes(term)
  );
});


const totalPagesV = Math.ceil(filteredVolunteers.length / itemsPerPageV);

const currentItems = filteredVolunteers.slice(
  (currentPageV - 1) * itemsPerPageV,
  currentPageV * itemsPerPageV
);

  
const downloadExcel = () => {
  const exportData = volunteers.map(v => ({
    Name: v.name,
    Email: v.email,
    Mobile: v.mobile,
    City: v.city,
    Aadhaar: maskAadhaar(v.aadhar_number),
    Registration_No: v.registration_no,
    Paid: v.isPaid ? "Paid" : "Not Paid",
    Approved: v.is_approved ? "Approved" : "Pending"
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Volunteers");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  saveAs(new Blob([excelBuffer]), "Volunteers.xlsx");
};

  const [items, setItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    title: "",
    description: "",
    type: "Thermal Card Printers", // default
    price: "",
    is_display: "display",
    images: [],
  });

  const [editing, setEditing] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Calculate pagination
  const totalPages = Math.ceil(items.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;


  useEffect(() => {
    fetchVolunteers();
  }, []);



  //------Media Page --------//

  //  const [media, setMedia] = useState([]);
  // const [formM, setFormM] = useState({ platform: "", url: "" });
  // const [editingM, setEditingM] = useState(null);
  // const [showModalM, setShowModalM] = useState(false);

  // // Pagination
  // const [currentPageM, setCurrentPageM] = useState(1);
  // const itemsPerPageM = 10;
  // const totalPagesM = Math.ceil(media.length / itemsPerPageM);
  // const currentItemsM = media.slice(
  //   (currentPageM - 1) * itemsPerPageM,
  //   currentPageM * itemsPerPageM
  // );

  // const fetchMedia = async () => {
  //   const { data } = await axios.get(`${API}/api/media`);
  //   setMedia(data);
  // };

  // useEffect(() => {
  //   fetchMedia();
  // }, []);

  // const handleChangeM = (e) => {
  //   setFormM({ ...formM, [e.target.name]: e.target.value });
  // };

  // const handleSubmitM = async (e) => {
  //   e.preventDefault();

  //   if (editingM) {
  //     await axios.put(`${API}/api/media/${editingM}`, formM);
  //   } else {
  //     await axios.post(`${API}/api/media`, formM);
  //   }

  //   setFormM({ platform: "", url: "" });
  //   setEditingM(null);
  //   setShowModalM(false);
  //   fetchMedia();
  // };

  // const handleEditM = (item) => {
  //   setFormM({ platform: item.platform, url: item.url });
  //   setEditingM(item.id);
  //   setShowModalM(true);
  // };

  // const handleDeleteM = async (id) => {
  //   if (window.confirm("Delete this media item?")) {
  //     await axios.delete(`${API}/api/media/${id}`);
  //     fetchMedia();
  //   }
  // };

  // const renderEmbed = (item) => {
  //   if (item.platform === "facebook")
  //     return <FacebookEmbed url={item.url} width={350} />;

  //   if (item.platform === "instagram")
  //     return <InstagramEmbed url={item.url} width={350} />;

  //   if (item.platform === "youtube")
  //     return <YouTubeEmbed url={item.url} width={350} height={200} />;

  //   return null;
  // };

 


  //---Bannersa Page -----//

const [banners, setBanners] = useState([]);
const [formB, setFormB] = useState({ image: null, section: "Hero Section" });

const [editingB, setEditingB] = useState(null);
const [showModalB, setShowModalB] = useState(false);

// Pagination
const [currentPageB, setCurrentPageB] = useState(1);
const itemsPerPageB = 10;
const totalPagesB = Math.ceil(banners.length / itemsPerPageB);
const currentItemsB = banners.slice(
  (currentPageB - 1) * itemsPerPageB,
  currentPageB * itemsPerPageB
);

const fetchBanners = async () => {
  const { data } = await axios.get(`${API}/api/banners`);
  setBanners(data);
};

useEffect(() => {
  fetchBanners();
}, []);

const handleImageB = (e) => {
  setFormB({ ...formB, image: e.target.files[0] });
};

const handleSectionChange = (e) => {
  setFormB({ ...formB, section: e.target.value });
};

const handleSubmitB = async (e) => {
  e.preventDefault();
  const data = new FormData();

  if (formB.image instanceof File) {
    data.append("image", formB.image);
  }
  data.append("section", formB.section);

  if (editingB) {
    await axios.put(`${API}/api/banners/${editingB}`, data);
  } else {
    await axios.post(`${API}/api/banners`, data);
  }

  setShowModalB(false);
  setFormB({ image: null, section: "Hero Section" });
  setEditingB(null);
  fetchBanners();
};


const handleEditB = (banner) => {
  setFormB({ image: banner.image, section: banner.section });
  setEditingB(banner.id);
  setShowModalB(true);
};


const handleDeleteB = async (id) => {
  if (window.confirm("Delete this banner?")) {
    await axios.delete(`${API}/api/banners/${id}`);
    fetchBanners();
  }
};


// --- Gallery Page ---- //

const [gallery, setGallery] = useState([]);
const [formG, setFormG] = useState({ image: null, image_text: "" });
const [editingG, setEditingG] = useState(null);
const [showModalG, setShowModalG] = useState(false);

// Pagination
const [currentPageG, setCurrentPageG] = useState(1);
const itemsPerPageG = 10;
const totalPagesG = Math.ceil(gallery.length / itemsPerPageG);
const currentItemsG = gallery.slice(
  (currentPageG - 1) * itemsPerPageG,
  currentPageG * itemsPerPageG
);

const fetchGallery = async () => {
  const { data } = await axios.get(`${API}/api/gallery`);
  setGallery(data);
};

useEffect(() => {
  fetchGallery();
}, []);

const handleImageG = (e) => {
  setFormG({ ...formG, image: e.target.files[0] });
};

const handleTextG = (e) => {
  setFormG({ ...formG, image_text: e.target.value });
};

const handleSubmitG = async (e) => {
  e.preventDefault();
  const data = new FormData();

  if (formG.image instanceof File) {
    data.append("image", formG.image);
  }
  data.append("image_text", formG.image_text);

  if (editingG) {
    await axios.put(`${API}/api/gallery/${editingG}`, data);
  } else {
    await axios.post(`${API}/api/gallery`, data);
  }

  setShowModalG(false);
  setFormG({ image: null, image_text: "" });
  setEditingG(null);
  fetchGallery();
};

const handleEditG = (item) => {
  setFormG({ image: item.image, image_text: item.image_text });
  setEditingG(item.id);
  setShowModalG(true);
};

const handleDeleteG = async (id) => {
  if (window.confirm("Delete this gallery item?")) {
    await axios.delete(`${API}/api/gallery/${id}`);
    fetchGallery();
  }
};

// --- Activities Page ---- //

const [activities, setActivities] = useState([]);
const [formA, setFormA] = useState({ activity_text: "" });
const [editingA, setEditingA] = useState(null);
const [showModalA, setShowModalA] = useState(false);

// Pagination
const [currentPageA, setCurrentPageA] = useState(1);
const itemsPerPageA = 10;
const totalPagesA = Math.ceil(activities.length / itemsPerPageA);
const currentItemsA = activities.slice(
  (currentPageA - 1) * itemsPerPageA,
  currentPageA * itemsPerPageA
);

const fetchActivities = async () => {
  const { data } = await axios.get(`${API}/api/activities`);
  setActivities(data);
};

useEffect(() => {
  fetchActivities();
}, []);

const handleChangeA = (e) => {
  setFormA({ activity_text: e.target.value });
};

const handleSubmitA = async (e) => {
  e.preventDefault();

  const payload = { activity_text: formA.activity_text };

  if (editingA) {
    await axios.put(`${API}/api/activities/${editingA}`, payload);
  } else {
    await axios.post(`${API}/api/activities`, payload);
  }

  setShowModalA(false);
  setFormA({ activity_text: "" });
  setEditingA(null);
  fetchActivities();
};

const handleEditA = (activity) => {
  setFormA({ activity_text: activity.activity_text });
  setEditingA(activity.id);
  setShowModalA(true);
};

const handleDeleteA = async (id) => {
  if (window.confirm("Delete this activity?")) {
    await axios.delete(`${API}/api/activities/${id}`);
    fetchActivities();
  }
};


// --- Social Links Page ---- //

const [socialLinks, setSocialLinks] = useState([]);
const [formS, setFormS] = useState({ social_link: "", social_type: "Facebook" });
const [editingS, setEditingS] = useState(null);
const [showModalS, setShowModalS] = useState(false);

// Pagination
const [currentPageS, setCurrentPageS] = useState(1);
const itemsPerPageS = 10;
const totalPagesS = Math.ceil(socialLinks.length / itemsPerPageS);
const currentItemsS = socialLinks.slice(
  (currentPageS - 1) * itemsPerPageS,
  currentPageS * itemsPerPageS
);

const fetchSocialLinks = async () => {
  const { data } = await axios.get(`${API}/api/social-links`);
  setSocialLinks(data);
};

useEffect(() => {
  fetchSocialLinks();
}, []);

const handleChangeS = (e) => {
  const { name, value } = e.target;
  setFormS({ ...formS, [name]: value });
};

const handleSubmitS = async (e) => {
  e.preventDefault();

  if (editingS) {
    await axios.put(`${API}/api/social-links/${editingS}`, formS);
  } else {
    await axios.post(`${API}/api/social-links`, formS);
  }

  setShowModalS(false);
  setFormS({ social_link: "", social_type: "Facebook" });
  setEditingS(null);
  fetchSocialLinks();
};

const handleEditS = (link) => {
  setFormS({ social_link: link.social_link, social_type: link.social_type });
  setEditingS(link.id);
  setShowModalS(true);
};

const handleDeleteS = async (id) => {
  if (window.confirm("Delete this social link?")) {
    await axios.delete(`${API}/api/social-links/${id}`);
    fetchSocialLinks();
  }
};


//---Divyangjan Volunteers----//

const [divVolunteers, setDivVolunteers] = useState([]);
const [loadingDiv, setLoadingDiv] = useState(true);
const [selectedDivVolunteer, setSelectedDivVolunteer] = useState(null);
const [showModalDiv, setShowModalDiv] = useState(false);
const [searchDiv, setSearchDiv] = useState("");

// Pagination
const [currentPageDiv, setCurrentPageDiv] = useState(1);
const itemsPerPageDiv = 20;

// Fetch Divyangjan volunteers
const fetchDivVolunteers = async () => {
  setLoadingDiv(true);
  try {
    const { data } = await axios.get(`https://api.garudasena.org/api/divyangjan/volunteers`);
    setDivVolunteers(data);
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingDiv(false);
  }
};

useEffect(() => {
  fetchDivVolunteers();
}, []);

const interestedAreas = (() => {
  if (!selectedDivVolunteer?.interested_areas) return [];
  try {
    // Remove extra quotes if they exist
    const cleaned = selectedDivVolunteer.interested_areas.replace(/^"|"$/g, '');
    return JSON.parse(cleaned);
  } catch (err) {
    console.error('Error parsing interested_areas', err);
    return [];
  }
})();

// Approve Divyangjan volunteer
const handleApproveDiv = async (id) => {
  if (!window.confirm("Approve this Divyangjan volunteer?")) return;

  try {
     setApprovingId(id);
    const res = await axios.post(`https://api.garudasena.org/api/divyangjan/approve/${id}`);
    if (res.data.success) {
      alert(`Approved ✅ Enroll ID: ${res.data.divyangjan_enroll_id}`);
      fetchDivVolunteers();
    }
  } catch (err) {
    alert(err.response?.data?.message || "Approval failed");
  }finally {
    setApprovingId(null); // hide spinner
  }
};

// Delete
const handleDeleteDiv = async (id) => {
  if (!window.confirm("Delete this Divyangjan volunteer?")) return;

  try {
    const res = await axios.delete(`https://api.garudasena.org/api/divyangjan/${id}`);
    if (res.data.success) {
      alert("Deleted successfully");
      setDivVolunteers(divVolunteers.filter(v => v.id !== id));
    } else {
      alert(res.data.message);
    }
  } catch (err) {
    alert("Error deleting volunteer");
  }
};

// Search & Pagination
const filteredDivVolunteers = divVolunteers.filter(v => {
  const term = searchDiv.toLowerCase();
  return (
    v.name?.toLowerCase().includes(term) ||
    v.email?.toLowerCase().includes(term) ||
    v.mobile?.toLowerCase().includes(term) ||
    v.city?.toLowerCase().includes(term) ||
    v.divyangjan_enroll_id?.toLowerCase().includes(term) ||
    v.aadhar_number?.toLowerCase().includes(term)
  );
});

const totalPagesDiv = Math.ceil(filteredDivVolunteers.length / itemsPerPageDiv);
const currentItemsDiv = filteredDivVolunteers.slice(
  (currentPageDiv - 1) * itemsPerPageDiv,
  currentPageDiv * itemsPerPageDiv
);

// Excel export
const downloadExcelDiv = () => {
  const exportData = divVolunteers.map(v => ({
    Name: v.name,
    Email: v.email,
    Mobile: v.mobile,
    City: v.city,
    Aadhaar: maskAadhaar(v.aadhar_number),
    Enroll_ID: v.divyangjan_enroll_id || "—",
    Approved: v.is_approved ? "Approved" : "Pending"
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Divyangjan Volunteers");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([excelBuffer]), "DivyangjanVolunteers.xlsx");
};


//---Volunteers----//



  // Fetch volunteers
  const fetchVolunteers = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`https://api.garudasena.org/api/volunteers/paid`);
      // filter only paid
      const paid = data.filter((v) => v.isPaid === 1);
      setVolunteers(paid);
    } catch (error) {
      console.error("Error fetching volunteers:", error);
    } finally {
      setLoading(false);
    }
  };



  // Mask Aadhaar
  const maskAadhaar = (num) => {
    if (!num) return "N/A";
    const last4 = num.slice(-4);
    return `XXXX-XXXX-${last4}`;
  };

  // Approve volunteer
  const handleApprove = async (id) => {
    if (!window.confirm("Approve this volunteer?")) return;

    setApprovingId(id); 

    try {
      await axios.post(`https://api.garudasena.org/api/volunteers/register/approve/${id}`);
      alert("Volunteer approved successfully!");
      fetchVolunteers();
    } catch (error) {
      console.error("Error approving volunteer:", error);
      alert("Failed to approve volunteer.");
    }finally {
    setApprovingId(null); // stop loading
  }
  };

  const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this volunteer?")) return;

  try {
    const res = await fetch(`https://api.garudasena.org/api/volunteers/${id}`, {
      method: "DELETE",
    });

    const data = await res.json();

    if (data.success) {
      alert("Volunteer deleted");
      setVolunteers(volunteers.filter((v) => v.id !== id));
    } else {
      alert(data.message);
    }
  } catch (err) {
    alert("Error deleting volunteer");
  }
};


  // ---------------- VIP Component ---------------- //

const [vipList, setVipList] = useState([]);
const [formVIP, setFormVIP] = useState({
  name: "",
  designation: "",
  photo: null,
  preview: null,   // <--- added
});
const [editingVIP, setEditingVIP] = useState(null);
const [showVIPModal, setShowVIPModal] = useState(false);
const [searchVIP, setSearchVIP] = useState("");


// Pagination
const [currentPageVIP, setCurrentPageVIP] = useState(1);
const itemsPerPageVIP = 10;

const filteredVIP = vipList.filter(v =>
  v.name.toLowerCase().includes(searchVIP.toLowerCase()) ||
  v.designation.toLowerCase().includes(searchVIP.toLowerCase())
);


const totalPagesVIP = Math.ceil(filteredVIP.length / itemsPerPageVIP);

const currentItemsVIP = filteredVIP.slice(
  (currentPageVIP - 1) * itemsPerPageVIP,
  currentPageVIP * itemsPerPageVIP
);


  const handlePageChangeVIP = (page) => {
    setCurrentPageVIP(page);
  };

// Fetch VIPs
const fetchVIP = async () => {
  const { data } = await axios.get(`${API}/api/vip`);
  setVipList(data);
};

useEffect(() => {
  fetchVIP();
}, []);

// Handle Input
// const handleVIPChange = (e) => {
//   const { name, value, files } = e.target;
//   setFormVIP({ ...formVIP, [name]: files ? files[0] : value });
// };

const handleVIPChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "photo") {
    const file = files[0];
    setFormVIP({
      ...formVIP,
      photo: file,
      preview: URL.createObjectURL(file), // 👈 preview generated
    });
  } else {
    setFormVIP({ ...formVIP, [name]: value });
  }
};


// Submit Add / Edit
const handleVIPSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  fd.append("name", formVIP.name);
  fd.append("designation", formVIP.designation);
  if (formVIP.photo) fd.append("photo", formVIP.photo);

  if (editingVIP) {
    await axios.put(`${API}/api/vip/${editingVIP}`, fd);
  } else {
    await axios.post(`${API}/api/vip`, fd);
  }

  setShowVIPModal(false);
  setFormVIP({ name: "", designation: "", photo: null });
  setEditingVIP(null);
  fetchVIP();
};

// Edit handler
const handleEditVIP = (vip) => {
  setFormVIP({
    name: vip.name,
    designation: vip.designation,
    photo: null,
  });
  setEditingVIP(vip.id);
  setShowVIPModal(true);
};

// Delete
const deleteVIP = async (id) => {
  if (window.confirm("Delete this VIP?")) {
    await axios.delete(`${API}/api/vip/${id}`);
    fetchVIP();
  }
};


const generateCertificate = async (id) => {
  try {
    const { data } = await axios.post(`https://api.garudasena.org/api/vip/generate-certificate/${id}`);
    alert("Certificate Generated Successfully!");

    fetchVIP(); // refresh table to show Download button
  } catch (err) {
    console.error(err);
    alert("Failed to generate certificate.");
  }
};


const generateIdCard = async (id) => {
  try {
    const { data } = await axios.post(
      `https://api.garudasena.org/api/vip/generate-id/${id}`
    );

    alert("ID Generated Successfully!");

    fetchVIP(); // refresh to show Download
  } catch (err) {
    console.error(err);
    alert("Failed to generate ID.");
  }
};



// -----------Certificates & ID ----------- //

  const [usersCI, setUsersCI] = useState([]);
  const [loadingCI, setLoadingCI] = useState(true);
  const [currentPageCI, setCurrentPageCI] = useState(1);
  const [itemsPerPageCI, setItemsPerPageCI] = useState(10);
  const [totalPagesCI, setTotalPagesCI] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetching users for certificates and ID
  const fetchUsersCI = async () => {
    setLoadingCI(true);
    try {
      const { data } = await axios.get("https://api.garudasena.org/api/certificates");  // Your API URL for certificates
      const paid = data.filter((v) => v.is_approved === 1);
      setUsersCI(paid);

      // Set total pages for pagination (if needed)
      setTotalPagesCI(Math.ceil(paid.length / itemsPerPageCI));
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadingCI(false);
    }
  };

  // Effect hook to fetch users
  useEffect(() => {
    fetchUsersCI();
  }, [currentPageCI]);

  // Filtered users based on the search query
  const filteredUsers = usersCI.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      user.name.toLowerCase().includes(query) ||
      user.email.toLowerCase().includes(query) ||
      user.mobile.toLowerCase().includes(query) ||
      user.registration_no.toLowerCase().includes(query) ||
      user.city.toLowerCase().includes(query)
    );
  });

  // Download the certificate or ID card
  const downloadFileCI = (url, fileType) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank"; // This will open the file in a new tab
      link.rel = "noopener noreferrer"; // For security reasons
      link.click();
    } else {
      alert(`No ${fileType} available for this user.`);
    }
  };

  // Pagination change handler
  const handlePageChangeCI = (page) => {
    setCurrentPageCI(page);
  };

  // Pagination logic
  const startIndexCI = (currentPageCI - 1) * itemsPerPageCI;
  const currentItemsCI = filteredUsers.slice(startIndexCI, startIndexCI + itemsPerPageCI);


  // ---------------- PROGRAM Component ---------------- //

const [programList, setProgramList] = useState([]);
const [formProgram, setFormProgram] = useState({
  program_name: "",
  description: "",
  contact_person: "",
  join_us: false,
  image: null,
  preview: null,
});
const [editingProgram, setEditingProgram] = useState(null);
const [showProgramModal, setShowProgramModal] = useState(false);
const [searchProgram, setSearchProgram] = useState("");

// Pagination
const [currentPagePRG, setCurrentPagePRG] = useState(1);
const itemsPerPagePRG = 10;

const filteredPrograms = programList.filter(p =>
  p.program_name.toLowerCase().includes(searchProgram.toLowerCase())
);

const totalPagesPRG = Math.ceil(filteredPrograms.length / itemsPerPagePRG);

const currentItemsPRG = filteredPrograms.slice(
  (currentPagePRG - 1) * itemsPerPagePRG,
  currentPagePRG * itemsPerPagePRG
);

const handlePageChangePRG = (page) => setCurrentPagePRG(page);

// Fetch Programs
const fetchPrograms = async () => {
  const { data } = await axios.get(`${API}/api/programs`);
  setProgramList(data);
};

useEffect(() => {
  fetchPrograms();
}, []);

// Handle Input
const handleProgramChange = (e) => {
  const { name, value, files, type, checked } = e.target;

  if (name === "image") {
    const file = files[0];
    setFormProgram({
      ...formProgram,
      image: file,
      preview: URL.createObjectURL(file),
    });
  } else if (type === "checkbox") {
    setFormProgram({ ...formProgram, [name]: checked });
  } else {
    setFormProgram({ ...formProgram, [name]: value });
  }
};

// Submit Add / Edit
const handleProgramSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  fd.append("program_name", formProgram.program_name);
  fd.append("description", formProgram.description);
  fd.append("contact_person", formProgram.contact_person);
  fd.append("join_us", formProgram.join_us ? 1 : 0);
  if (formProgram.image) fd.append("image", formProgram.image);

  if (editingProgram) {
    await axios.put(`${API}/api/programs/${editingProgram}`, fd);
  } else {
    await axios.post(`${API}/api/programs`, fd);
  }

  setShowProgramModal(false);
  setFormProgram({ program_name: "", description: "", contact_person: "", join_us: false, image: null });
  setEditingProgram(null);
  fetchPrograms();
};

// Edit
const handleEditProgram = (prg) => {
  setFormProgram({
    program_name: prg.program_name,
    description: prg.description,
    contact_person: prg.contact_person,
    join_us: prg.join_us ? true : false,
    image: null,
    preview: prg.image,
  });

  setEditingProgram(prg.id);
  setShowProgramModal(true);
};

// Delete
const deleteProgram = async (id) => {
  if (window.confirm("Delete this program?")) {
    await axios.delete(`${API}/api/programs/${id}`);
    fetchPrograms();
  }
};



// ================= Volunteer Edit Component =================

const [volunteersV, setVolunteersV] = useState([]);
const [showModalVE, setShowModalVE] = useState(false);
const [editingV, setEditingV] = useState(null);

// Form
const [formV, setFormV] = useState({
  name: "",
  email: "",
  mobile: "",
  profile_image: null,
});

// Pagination
const [currentPageVE, setCurrentPageVE] = useState(1);
const itemsPerPageVE = 10;

const [searchTermVE, setSearchTermVE] = useState("");
const [sendingCertId, setSendingCertId] = useState(null);
const [sendingIdCardId, setSendingIdCardId] = useState(null);


// ✅ GUIDE: Fetch paid volunteers
const fetchVolunteersV = async () => {
  const { data } = await axios.get(
    "https://api.garudasena.org/api/volunteers/paid"
  );

   const paid = data.filter((v) => v.isPaid === 1);
  setVolunteersV(paid);
};

useEffect(() => {
  fetchVolunteersV();
}, []);


const filteredVolunteersVE = volunteersV.filter((v) =>
  [v.name, v.email, v.mobile]
    .join(" ")
    .toLowerCase()
    .includes(searchTermVE.toLowerCase())
);

const totalPagesVE = Math.ceil(filteredVolunteersVE.length / itemsPerPageVE);

const currentItemsVE = filteredVolunteersVE.slice(
  (currentPageVE - 1) * itemsPerPageVE,
  currentPageVE * itemsPerPageVE
);


// ✅ GUIDE: Handle edit click
const handleEditV = (v) => {
  setEditingV(v.id);
  setFormV({
    name: v.name,
    email: v.email,
    mobile: v.mobile,
    profile_image: v.profile_image,
  });
  setShowModalVE(true);
};

// ✅ GUIDE: File change
const handleImageV = (e) => {
  setFormV({ ...formV, profile_image: e.target.files[0] });
};

// ✅ GUIDE: Update volunteer
const handleSubmitV = async (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append("name", formV.name);
  data.append("email", formV.email);
  data.append("mobile", formV.mobile);

  if (formV.profile_image instanceof File) {
    data.append("photo", formV.profile_image); // ✅ MATCH BACKEND
  }

  try {
    const res = await axios.put(
      `https://api.garudasena.org/api/volunteer/${editingV}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // ✅ SUCCESS ALERT
    alert(res.data.message || "Volunteer updated successfully");

    setShowModalVE(false);
    setEditingV(null);
    fetchVolunteersV();

  } catch (err) {
    console.error(err);

    // ❌ API ERROR ALERT
    if (err.response) {
      alert(err.response.data.message || "Update failed");
    } else {
      alert("Server not reachable. Please try again.");
    }
  }
};


// ✅ GUIDE: Resend certificate
// ✅ Resend / Generate Certificate
const resendCertificate = async (id) => {
    setSendingCertId(id);
  try {
    const res = await axios.post(
      `https://api.garudasena.org/api/volunteers/${id}/generate-certificate`
    );

    // ✅ SUCCESS
    alert(
      res.data?.success
        ? "Certificate generated and sent successfully"
        : "Certificate process completed"
    );

  } catch (err) {
    console.error(err);

    // ❌ API ERROR HANDLING
    if (err.response) {
      alert(err.response.data.message || "Failed to resend certificate");
    } else {
      alert("Server not reachable. Please try again.");
    }
  }finally {
    setSendingCertId(null);
  }
};




// ✅ Resend / Generate ID Card
const resendIdCard = async (id) => {
   setSendingIdCardId(id);
  try {
    const res = await axios.post(
      `https://api.garudasena.org/api/volunteers/${id}/generate-idcard`
    );

    // ✅ SUCCESS ALERT
    alert(
      res.data?.message || "ID Card generated and sent successfully"
    );

  } catch (err) {
    console.error(err);

    // ❌ API ERROR HANDLING
    if (err.response) {
      alert(err.response.data.message || "Failed to resend ID Card");
    } else {
      alert("Server not reachable. Please try again.");
    }
  }finally {
    setSendingIdCardId(null);
  }
};





  const allNavItems = [
    { label: "Dashboard", icon: <MdDashboard /> },
    { label: "Volunteers", icon: <MdGroup/>},
    { label: "Divyangjan Volunteers", icon: <MdGroup /> },

    {label:"Volunteers Edit", icon:<MdEdit/>},
    { label: "VIPs", icon: <MdBadge /> },
    { label: "Certificates & IDs", icon: <FaCertificate /> }, 
    { label: "Programs", icon: <MdTv /> }, 
    // {label:"Media Page", icon:<MdPostAdd/> },
    { label: "Banners", icon: <MdStore /> },
    { label: "Gallery", icon: <MdImage /> },
    { label: "Activities", icon: <MdEvent /> },   
    {label: "Social Links", icon: <MdLink /> }
  ];

useEffect(() => {
    localStorage.setItem("activeComponent", activeComponent);
  }, [activeComponent]);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(e.target)
      ) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

const handleLogout = () => {
  sessionStorage.removeItem("isAdminLoggedIn");
  sessionStorage.removeItem("adminEmail");
  navigate("/admin-login");
};




  const renderContent = () => {
if (activeComponent === "Banners") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Banners</h2>
        <button
          onClick={() => {
            setFormB({ image: null });
            setEditingB(null);
            setShowModalB(true);
          }}
          style={{
            background: "var(--accent)",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
     <thead style={{ background: "var(--primary)", color: "#fff" }}>
  <tr>
    <th>#</th>
    <th>Image</th>
    <th>Section</th>
    <th>Actions</th>
  </tr>
</thead>
<tbody>
  {currentItemsB.map((banner, i) => (
    <tr key={banner.id}>
      <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{i + 1}</td>
      <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>
        <img
          src={banner.image}
          alt="banner"
          style={{ width: 100, height: "auto", borderRadius: 6 }}
        />
      </td>
      <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{banner.section}</td>
      <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>
        <button
          onClick={() => handleEditB(banner)}
          style={{ background: "var(--primary)", color: "#fff", marginRight: 6 , cursor:'pointer'}}
        >
          <FaEdit />
        </button>
        <button
          onClick={() => handleDeleteB(banner.id)}
          style={{ background: "var(--accent)", color: "#fff" , cursor:'pointer'}}
        >
          <FaTrash />
        </button>
      </td>
    </tr>
  ))}
</tbody>

      </table>

      {/* Modal */}
{showModalB && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      backdropFilter: "blur(2px)",
    }}
  >
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        width: "90%",
        maxWidth: 420,
        padding: "25px 25px 30px",
        boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
        position: "relative",
        animation: "fadeIn 0.3s ease",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
          borderBottom: "1px solid #eee",
          paddingBottom: 10,
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "18px",
            color: "var(--primary)",
            fontWeight: 600,
          }}
        >
          {editingB ? "Edit Banner" : "Add Banner"}
        </h3>
        <FaTimes
          onClick={() => setShowModalB(false)}
          style={{
            cursor: "pointer",
            color: "#555",
            fontSize: 18,
            transition: "0.2s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "var(--accent)")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
        />
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmitB}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 15,
        }}
      >
        {/* File Input */}
        <label
          style={{
            width: "100%",
            textAlign: "left",
            fontWeight: 600,
            fontSize: 14,
            color: "#333",
          }}
        >
          Upload Banner Image
        </label>

        <input
          type="file"
          accept="image/*"
          onChange={handleImageB}
          style={{
            width: "100%",
            border: "1px solid #ccc",
            borderRadius: 6,
            padding: "8px",
            fontSize: 14,
            cursor: "pointer",
          }}
        />

        <label
  style={{
    width: "100%",
    textAlign: "left",
    fontWeight: 600,
    fontSize: 14,
    color: "#333",
  }}
>
  Select Section
</label>

<select
  value={formB.section}
  onChange={handleSectionChange}
  style={{
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: "8px",
    fontSize: 14,
    cursor: "pointer",
  }}
>
  <option value="Hero Section">Hero Section</option>
  <option value="About Us">About Us</option>
</select>


        {/* Image Preview */}
        {formB.image && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: 10,
            }}
          >
            <img
              src={
                typeof formB.image === "string"
                  ? formB.image
                  : URL.createObjectURL(formB.image)
              }
              alt="preview"
              style={{
                width: "100%",
                maxWidth: 250,
                height: "auto",
                borderRadius: 8,
                objectFit: "cover",
                border: "1px solid #eee",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            />
          </div>
        )}

        {/* Submit Button */}
        <button
          type="submit"
          style={{
            background: "var(--accent)",
            color: "#fff",
            padding: "10px 15px",
            borderRadius: 6,
            marginTop: 15,
            width: "100%",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            border: "none",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--accent)")
          }
        >
          {editingB ? "Update Banner" : "Add Banner"}
        </button>
      </form>
    </div>
  </div>
)}

    </div>
  );
}


if (activeComponent === "Volunteers Edit") {
  return (
     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ color: "var(--primary)" }}>Volunteers Edit</h2>

        {/* Search */}
        <input
          type="text"
          placeholder="Search name, email, mobile..."
          value={searchTermVE}
          onChange={(e) => {
            setSearchTermVE(e.target.value);
            setCurrentPageVE(1);
          }}
          style={{
            padding: "10px 15px",
            width: 280,
            borderRadius: 8,
            border: "1px solid #ccc",
            outline: "none",
          }}
        />
      </div>

      <table  style={{
      width: "100%",
      borderCollapse: "collapse",
      minWidth: "900px",
      border: "1px solid #ddd",
    }}>
  <thead style={{ background: "var(--primary)", color: "#fff" }}>
    <tr>
      <th>#</th>
      <th>Photo</th>
      <th>Name</th>
      <th>Email</th>
      <th>Mobile</th>
      <th>Certificate</th>
      <th>ID Card</th>
      <th>Action</th>
    </tr>
  </thead>

  <tbody>
    {currentItemsVE.map((v, i) => (
      <tr key={v.id}>
        <td style={tdStyle}>{i + 1}</td>

        <td  style={{ textAlign: "center",
  border: "1px solid #ddd",
  padding: "8px"}}>
          <img
            src={v.profile_image}
            alt=""
           style={{ width: 50, height: 50, borderRadius: "50%", objectFit: "cover",  }}
          />
        </td>

        <td style={tdStyle}>{v.name}</td>
        <td style={tdStyle}>{v.email}</td>
        <td style={tdStyle}>{v.mobile}</td>

<td style={{ textAlign: "center", border: "1px solid #ddd", padding: "8px" }}>
  <button
    onClick={() => resendCertificate(v.id)}
    disabled={sendingCertId === v.id}
    style={{
      background: "var(--primary)",
      color: "#fff",
      borderRadius: "8px",
      padding: "8px",
      cursor: sendingCertId === v.id ? "not-allowed" : "pointer",
      opacity: sendingCertId === v.id ? 0.7 : 1,
    }}
  >
    {sendingCertId === v.id ? "Sending..." : "Re Send"}
  </button>
</td>


<td style={{ textAlign: "center", border: "1px solid #ddd", padding: "8px" }}>
  <button
    onClick={() => resendIdCard(v.id)}
    disabled={sendingIdCardId === v.id}
    style={{
      background: "var(--accent)",
      color: "#fff",
      borderRadius: "8px",
      padding: "8px",
      cursor: sendingIdCardId === v.id ? "not-allowed" : "pointer",
      opacity: sendingIdCardId === v.id ? 0.7 : 1,
    }}
  >
    {sendingIdCardId === v.id ? "Sending..." : "Re Send"}
  </button>
</td>


        <td  style={{ textAlign: "center",
  border: "1px solid #ddd",
  padding: "8px"}}>
          <button
            onClick={() => handleEditV(v)}
            style={{ background: "var(--primary)", color: "#fff" }}
          >
            <FaEdit />
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
{/* Pagination */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: 15,
    gap: 10,
  }}
>
  {Array.from({ length: totalPagesVE }).map((_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPageVE(i + 1)}
      style={{
        padding: "6px 12px",
        background:
          currentPageVE === i + 1 ? "var(--primary)" : "#eee",
        color: currentPageVE === i + 1 ? "#fff" : "#333",
        border: "none",
        borderRadius: 4,
        cursor: "pointer",
      }}
    >
      {i + 1}
    </button>
  ))}
</div>

{showModalVE && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: 20,
        paddingTop: 5,
        paddingRight: 30,
        borderRadius: 12,
        width: "420px",
        maxHeight: "85vh",
        minHeight: "360px",
        overflowY: "auto",
        boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            color: "var(--primary)",
            fontWeight: 600,
            margin: 0,
          }}
        >
          Edit Volunteer
        </h3>

        <FaTimes
          onClick={() => setShowModalVE(false)}
          style={{
            cursor: "pointer",
            color: "#555",
            fontSize: 18,
            transition: "0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.color = "var(--accent)")
          }
          onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
        />
      </div>

      {/* Form */}
      <form
        onSubmit={handleSubmitV}
        style={{ display: "flex", flexDirection: "column", gap: 15 }}
      >
        <label>Name</label>
        <input
          value={formV.name}
          onChange={(e) => setFormV({ ...formV, name: e.target.value })}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 6,
            border: "1px solid #ccc",
          }}
          required
        />

        <label>Email</label>
        <input
          value={formV.email}
          onChange={(e) => setFormV({ ...formV, email: e.target.value })}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 6,
            border: "1px solid #ccc",
          }}
          required
        />

        <label>Mobile</label>
        <input
          value={formV.mobile}
          onChange={(e) => setFormV({ ...formV, mobile: e.target.value })}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 6,
            border: "1px solid #ccc",
          }}
          required
        />

        <label>Profile Image</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageV}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 6,
            border: "1px solid #ccc",
          }}
        />

        {formV.profile_image && (
          <img
            src={
              typeof formV.profile_image === "string"
                ? formV.profile_image
                : URL.createObjectURL(formV.profile_image)
            }
            alt="Preview"
            style={{
              width: 100,
              height: 100,
              objectFit: "cover",
              borderRadius: 8,
              marginTop: 10,
              border: "1px solid #eee",
            }}
          />
        )}

        <button
          type="submit"
          style={{
            background: "var(--accent)",
            color: "#fff",
            padding: "10px 15px",
            borderRadius: 6,
            marginTop: 15,
            width: "100%",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer",
            border: "none",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--accent)")
          }
        >
          Update Volunteer
        </button>
      </form>
    </div>
  </div>
)}


    </div>
  )
}

if (activeComponent === "Gallery") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Gallery</h2>
        <button
          onClick={() => {
            setFormG({ image: null, image_text: "" });
            setEditingG(null);
            setShowModalG(true);
          }}
          style={{
            background: "var(--accent)",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Text</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentItemsG.map((item, i) => (
            <tr key={item.id}>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{i + 1}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>
                <img
                  src={item.image}
                  alt="gallery"
                  style={{
                    width: 100,
                    height: "auto",
                    borderRadius: 6,
                    objectFit: "cover",
                  }}
                />
              </td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{item.image_text}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>
                <button
                  onClick={() => handleEditG(item)}
                  style={{
                    background: "var(--primary)",
                    color: "#fff",
                    marginRight: 6,
                    cursor:'pointer'
                  }}
                >
                  <FaEdit />
                </button>
                <button
                  onClick={() => handleDeleteG(item.id)}
                  style={{ background: "var(--accent)", color: "#fff" , cursor:'pointer'}}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModalG && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(2px)",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 420,
              padding: "25px 25px 30px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
              position: "relative",
              animation: "fadeIn 0.3s ease",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
                borderBottom: "1px solid #eee",
                paddingBottom: 10,
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  color: "var(--primary)",
                  fontWeight: 600,
                }}
              >
                {editingG ? "Edit Gallery Item" : "Add Gallery Item"}
              </h3>
              <FaTimes
                onClick={() => setShowModalG(false)}
                style={{
                  cursor: "pointer",
                  color: "#555",
                  fontSize: 18,
                  transition: "0.2s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.color = "var(--accent)")
                }
                onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
              />
            </div>

            {/* Form */}
            <form
              onSubmit={handleSubmitG}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 15,
              }}
            >
              {/* Text Input */}
              <label
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: 600,
                  fontSize: 14,
                  color: "#333",
                }}
              >
                Image Text
              </label>
              <input
                type="text"
                value={formG.image_text}
                onChange={handleTextG}
                placeholder="Enter image description"
                required
                style={{
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: "8px",
                  fontSize: 14,
                }}
              />

              {/* Image Upload */}
              <label
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: 600,
                  fontSize: 14,
                  color: "#333",
                }}
              >
                Upload Image
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageG}
                style={{
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: "8px",
                  fontSize: 14,
                  cursor: "pointer",
                }}
              />

              {/* Image Preview */}
              {formG.image && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 10,
                  }}
                >
                  <img
                    src={
                      typeof formG.image === "string"
                        ? formG.image
                        : URL.createObjectURL(formG.image)
                    }
                    alt="preview"
                    style={{
                      width: "100%",
                      maxWidth: 250,
                      borderRadius: 8,
                      border: "1px solid #eee",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              )}

              {/* Submit */}
              <button
                type="submit"
                style={{
                  background: "var(--accent)",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: 6,
                  marginTop: 15,
                  width: "100%",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                  border: "none",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "var(--primary)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "var(--accent)")
                }
              >
                {editingG ? "Update Gallery Item" : "Add Gallery Item"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
if (activeComponent === "Activities") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Activities</h2>
        <button
          onClick={() => {
            setFormA({ activity_text: "" });
            setEditingA(null);
            setShowModalA(true);
          }}
          style={{
            background: "var(--accent)",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th>#</th>
            <th>Activity Text</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentItemsA.map((activity, i) => (
            <tr key={activity.id}>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{i + 1}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{activity.activity_text}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>
                <button
                  onClick={() => handleEditA(activity)}
                  style={{
                    background: "var(--primary)",
                    color: "#fff",
                    marginRight: 6,
                   cursor:'pointer'
                  }}
                >
                  <FaEdit />
                </button>
                <button
                  onClick={() => handleDeleteA(activity.id)}
                  style={{ background: "var(--accent)", color: "#fff" , cursor:'pointer'}}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModalA && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(2px)",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 420,
              padding: "25px 25px 30px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
              position: "relative",
              animation: "fadeIn 0.3s ease",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
                borderBottom: "1px solid #eee",
                paddingBottom: 10,
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  color: "var(--primary)",
                  fontWeight: 600,
                }}
              >
                {editingA ? "Edit Activity" : "Add Activity"}
              </h3>
              <FaTimes
                onClick={() => setShowModalA(false)}
                style={{
                  cursor: "pointer",
                  color: "#555",
                  fontSize: 18,
                  transition: "0.2s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.color = "var(--accent)")
                }
                onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
              />
            </div>

            {/* Form */}
            <form
              onSubmit={handleSubmitA}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 15,
              }}
            >
              {/* Text Input */}
              <label
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: 600,
                  fontSize: 14,
                  color: "#333",
                }}
              >
                Activity Text
              </label>
              <input
                type="text"
                value={formA.activity_text}
                onChange={handleChangeA}
                placeholder="Enter activity name"
                required
                style={{
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: "8px",
                  fontSize: 14,
                }}
              />

              {/* Submit */}
              <button
                type="submit"
                style={{
                  background: "var(--accent)",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: 6,
                  marginTop: 15,
                  width: "100%",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                  border: "none",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "var(--primary)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "var(--accent)")
                }
              >
                {editingA ? "Update Activity" : "Add Activity"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

if (activeComponent === "Programs") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      
      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ color: "var(--primary)" }}>Programs</h2>

        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Search programs..."
            value={searchProgram}
            onChange={(e) => {
              setSearchProgram(e.target.value);
              setCurrentPagePRG(1);
            }}
            style={{
              padding: "10px 14px",
              width: "260px",
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
          />

          <button
            onClick={() => {
              setFormProgram({ program_name: "", description: "", join_us: false, contact_person: "", image: null });
              setEditingProgram(null);
              setShowProgramModal(true);
            }}
            style={{
              background: "var(--accent)",
              color: "#fff",
              border: "none",
              padding: "8px 13px",
              borderRadius: 6,
              marginLeft: 10,
              cursor: "pointer",
            }}
          >
            Add Program
          </button>
        </div>
      </div>

      {/* TABLE */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th>#</th>
            <th>Program</th>
            <th>Description</th>
            <th>Image</th>
            <th>Join Us</th>
            <th>Contact Person</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsPRG.map((p, i) => (
            <tr key={p.id}>
              <td style={{ textAlign: "center" }}>{i + 1}</td>
              <td style={{ textAlign: "center" }}>{p.program_name}</td>
              <td style={{ textAlign: "center" }}>{p.description}</td>
              <td style={{ textAlign: "center" }}>
                <img src={p.image} alt="" style={{ width: 70, height: 70, borderRadius: 6 }} />
              </td>
              <td style={{ textAlign: "center" }}>{p.join_us ? "Yes" : "No"}</td>
              <td style={{ textAlign: "center" }}>{p.contact_person}</td>

              <td style={{ textAlign: "center" }}>
               
                 <button
                  onClick={() => handleEditProgram(p)}
                  style={{
                    background: "var(--primary)",
                    color: "#fff",
                    marginRight: 6,
                    cursor: "pointer",
                    border: "none",
                    padding: "6px 8px",
                  }}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={() => deleteProgram(p.id)}
                  style={{
                    background: "var(--accent)",
                    color: "#fff",
                    cursor: "pointer",
                    border: "none",
                    padding: "6px 8px",
                  }}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 15, gap: 10 }}>
        {Array.from({ length: totalPagesPRG }).map((_, i) => (
          <button
            key={i}
            onClick={() => handlePageChangePRG(i + 1)}
            style={{
              padding: "6px 12px",
              background: currentPagePRG === i + 1 ? "#7B1E3A" : "#eee",
              color: currentPagePRG === i + 1 ? "#fff" : "#333",
              borderRadius: 4,
              border: "none",
            }}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* MODAL */}
      {showProgramModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
       <div
  style={{
    background: "#fff",
    padding: 20,
    paddingTop: 1,
    paddingRight: 30,
    borderRadius: 12,
    width: "420px",
    maxHeight: "85vh",          // 👈 Limit height
    minHeight: "380px",         // 👈 Minimum height so it does not shrink
    overflowY: "auto",          // 👈 Enable scrolling
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
  }}
>

               <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
      
            
              }}
            >
            <h3 style={{   fontSize: "18px",
                  color: "var(--primary)",
                  fontWeight: 600,}}>{editingProgram ? "Edit Program" : "Add Program"}</h3>
             <FaTimes
                onClick={() => setShowProgramModal(false)}
                style={{
                  cursor: "pointer",
                  color: "#555",
                  fontSize: 18,
                  transition: "0.2s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.color = "var(--accent)")
                }
                onMouseOut={(e) => (e.currentTarget.style.color = "#555")}
              />
</div>
            <form onSubmit={handleProgramSubmit} style={{ display: "flex", flexDirection: "column", gap: 15 }}>
              <label>Program Name</label>
              <input name="program_name" type="text" style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }} value={formProgram.program_name} onChange={handleProgramChange} required />

              <label>Description</label>
              <textarea name="description" style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }}  value={formProgram.description} onChange={handleProgramChange} ></textarea>

              <label>Contact Person</label>
              <input name="contact_person" type="text" style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }} value={formProgram.contact_person} onChange={handleProgramChange} />

              <label>
                <input type="checkbox" name="join_us" checked={formProgram.join_us} onChange={handleProgramChange} />
                &nbsp;Show Join Us Button
              </label>

              <label>Program Image</label>
              <input name="image" type="file" style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }} accept="image/*" onChange={handleProgramChange} />

              {formProgram.preview && (
                <img src={formProgram.preview} alt="Preview" style={{ width: 90, height: 90, marginTop: 10 }} />
              )}

              <button type="submit"   style={{
                  background: "var(--accent)",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: 6,
                  marginTop: 15,
                  width: "100%",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                  border: "none",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "var(--primary)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "var(--accent)")
                }>
                {editingProgram ? "Update Program" : "Add Program"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}


if (activeComponent === "Social Links") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>Social Links</h2>
        <button
          onClick={() => {
            setFormS({ social_link: "", social_type: "Facebook" });
            setEditingS(null);
            setShowModalS(true);
          }}
          style={{
            background: "var(--accent)",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add
        </button>
      </div>

      {/* Table */}
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th>#</th>
            <th>Social Link</th>
            <th>Social Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentItemsS.map((link, i) => (
            <tr key={link.id}>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{i + 1}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{link.social_link}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>{link.social_type}</td>
              <td style={{ textAlign: "center" , border: "1px solid #ddd"}}>
                <button
                  onClick={() => handleEditS(link)}
                  style={{ background: "var(--primary)", color: "#fff", marginRight: 6 , cursor:'pointer'}}
                >
                  <FaEdit />
                </button>
                <button
                  onClick={() => handleDeleteS(link.id)}
                  style={{ background: "var(--accent)", color: "#fff" , cursor:'pointer'}}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      {showModalS && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            backdropFilter: "blur(2px)",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 420,
              padding: "25px 25px 30px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
                borderBottom: "1px solid #eee",
                paddingBottom: 10,
              }}
            >
              <h3 style={{ margin: 0, fontSize: "18px", color: "var(--primary)", fontWeight: 600 }}>
                {editingS ? "Edit Social Link" : "Add Social Link"}
              </h3>
              <FaTimes
                onClick={() => setShowModalS(false)}
                style={{ cursor: "pointer", color: "#555", fontSize: 18 }}
              />
            </div>

            <form
              onSubmit={handleSubmitS}
              style={{ display: "flex", flexDirection: "column", gap: 15 }}
            >
              <label style={{ fontWeight: 600 }}>Social Link</label>
              <input
                type="url"
                name="social_link"
                value={formS.social_link}
                onChange={handleChangeS}
                placeholder="https://example.com"
                required
                style={{ width: "100%", border: "1px solid #ccc", borderRadius: 6, padding: 8 }}
              />

              <label style={{ fontWeight: 600 }}>Social Type</label>
              <select
                name="social_type"
                value={formS.social_type}
                onChange={handleChangeS}
                required
                style={{ width: "100%", border: "1px solid #ccc", borderRadius: 6, padding: 8 }}
              >
                <option value="Facebook">Facebook</option>
                <option value="Instagram">Instagram</option>
                <option value="YouTube">YouTube</option>
                <option value="Twitter">Twitter</option>
              </select>

              <button
                type="submit"
                style={{
                  background: "var(--accent)",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: 6,
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                  border: "none",
                }}
              >
                {editingS ? "Update Social Link" : "Add Social Link"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}


if(activeComponent==='Volunteers'){
    return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" ,  alignItems: "center",}}>
        <h2 style={{ color: "var(--primary)" }}>Volunteers</h2>
        <div style={{
  display: "flex",

  alignItems: "center",
  marginBottom: 1,
}}>

  {/* Search Bar */}
  <input
    type="text"
    placeholder="Search name, email, mobile, city, registration..."
    value={searchTerm}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      setCurrentPageV(1); // reset pagination
    }}
    style={{
      padding: "10px 15px",
      width: "280px",
      borderRadius: 8,
      border: "1px solid #ccc",
      outline: "none"

    }}
  />

  {/* Download Excel */}
  <button
    onClick={downloadExcel}
    style={{
      background: "#7B1E3A",
      color: "#fff",
      padding: "10px 18px",
      borderRadius: 8,
      cursor: "pointer",
      border: "none",
      fontWeight: 600,
        marginLeft: 10,
    }}
  >
    📥 Download Excel
  </button>

</div>

      </div>



      {/* Table */}
      <div style={{ overflowX: "auto", marginTop: 20 }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "800px",
            border: "1px solid #ddd",
          }}
        >
          <thead style={{ background: "var(--primary)", color: "#fff" }}>
            <tr>
              <th>#</th>
              <th>Profile</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Aadhaar</th>
              <th>City</th>
              <th>Status</th>
              <th>Actions</th>
               <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((v, i) => (
              <tr key={v.id}>
                <td style={tdStyle}>{i + 1}</td>
                <td style={tdStyle}>
                  <img
                    src={v.profile_image}
                    alt="profile"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </td>
                <td style={tdStyle}>{v.name}</td>
                <td style={tdStyle}>{v.email}</td>
                <td style={tdStyle}>{v.mobile}</td>
                <td style={tdStyle}>{maskAadhaar(v.aadhar_number)}</td>
                <td style={tdStyle}>{v.city}</td>
                 <td style={tdStyle}>
          {v.is_approved === 1 ? (
            <span
              style={{
                background: "linear-gradient(90deg, #28a745, #5cd68a)",
                color: "#fff",
                padding: "5px 12px",
                borderRadius: 20,
                fontSize: 13,
                fontWeight: 600,
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              Approved
            </span>
          ) : (
            <span
              style={{
                background: "linear-gradient(90deg, #ff9800, #ffc107)",
                color: "#fff",
                padding: "5px 12px",
                borderRadius: 20,
                fontSize: 13,
                fontWeight: 600,
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              Pending
            </span>
          )}
        </td>
                <td style={tdStyle}>
                  <button
                    onClick={() => {
                      setSelectedVolunteer(v);
                      setShowModal(true);
                    }}
                    style={{
                      background: "var(--primary)",
                      color: "#fff",
                      marginRight: 6,
                      cursor: "pointer",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: 6,
                    }}
                  >
                    <FaEye />
                  </button>
<button
  onClick={() => handleApprove(v.id)}
  disabled={v.is_approved === 1 || approvingId === v.id}
  style={{
    background:
      v.is_approved === 1 ? "#bbb" : "var(--accent)",
    color: "#fff",
    cursor:
      v.is_approved === 1
        ? "not-allowed"
        : approvingId === v.id
        ? "wait"
        : "pointer",
    border: "none",
    padding: "5px 10px",
    borderRadius: 6,
    opacity: v.is_approved === 1 ? 0.7 : 1,
    transition: "0.3s",
  }}
>
  {approvingId === v.id ? (
    <>
    <style>{spinKeyframes}</style>
    <span style={spinnerStyle}></span>
    </>
  ) : (
    <FaCheck />
  )}
</button>

                </td>
                  <td style={tdStyle}>
        <button
          onClick={() => handleDelete(v.id)}
          style={{
            background: "#e63946",
            color: "white",
            border: "none",
            padding: "5px 10px",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          <FaTrash />
        </button>
      </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 15,
          gap: 10,
        }}
      >
        {Array.from({ length: totalPagesV }).map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPageV(i + 1)}
            style={{
              padding: "6px 12px",
              background: currentPageV === i + 1 ? "var(--primary)" : "#eee",
              color: currentPageV === i + 1 ? "#fff" : "#333",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* Volunteer Detail Modal */}
 {showModal && selectedVolunteer && (
  <div style={modalBackdrop}>
    <div style={modalBox}>
      {/* Header */}
      <div style={modalHeader}>
        <h3
          style={{
            margin: 0,
            color: "#fff",
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          Volunteer Details
        </h3>
        <FaTimes
          style={{
            cursor: "pointer",
            color: "#fff",
            fontSize: 18,
          }}
          onClick={() => setShowModal(false)}
        />
      </div>

   {/* Profile Section */}
<div
  style={{
    textAlign: "center",
    marginBottom: 20,
    marginTop: 10,
  }}
>
  <img
    src={selectedVolunteer.profile_image}
    alt={selectedVolunteer.name}
    style={{
      width: 100,
      height: 100,
      borderRadius: "50%",
      objectFit: "cover",
      border: "3px solid var(--accent)",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    }}
  />

  <h3
    style={{
      marginTop: 10,
      color: "var(--primary)",
      fontWeight: 700,
      fontSize: 20,
    }}
  >
    {selectedVolunteer.name}
  </h3>

  <p
    style={{
      marginTop: -5,
      color: "#ddb336ff",
      fontWeight: 600,
      fontSize: 14,
    }}
  >
    Reg No: {selectedVolunteer.registration_no}
  </p>

  <p style={{ color: "#666", fontSize: 14 }}>
    {selectedVolunteer.city}, {selectedVolunteer.state}
  </p>
</div>


      {/* Info Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12,
          fontSize: 14,
          color: "#333",
        }}
      >
        <Info label="Email" value={selectedVolunteer.email} />
        <Info label="Mobile" value={selectedVolunteer.mobile} />
        <Info label="Country" value={selectedVolunteer.country} />
        <Info label="Aadhaar" value={selectedVolunteer.aadhar_number} />
        <Info label="Payment" value={selectedVolunteer.isPaid ? "✅ Paid" : "❌ Pending"} />
        <Info label="Order ID" value={selectedVolunteer.orderId || "—"} />
        <Info
          label="Payment Status"
          value={selectedVolunteer.payment_status || "—"}
        />
        <Info label="Remarks" value={selectedVolunteer.remarks || "—"} />
      </div>

      {/* Interested Areas */}
      {selectedVolunteer.interested_areas && (
        <div
          style={{
            marginTop: 25,
            background: "#fafafa",
            padding: "15px 18px",
            borderRadius: 8,
            border: "1px solid #eee",
          }}
        >
          <h4
            style={{
              margin: "0 0 10px 0",
              fontSize: 15,
              fontWeight: 600,
              color: "var(--primary)",
            }}
          >
            Interested Areas
          </h4>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {JSON.parse(selectedVolunteer.interested_areas).map((area, idx) => (
              <span
                key={idx}
                style={{
                  background: "linear-gradient(135deg, #7B1E3A, #F2C94C)",
                  color: "#fff",
                  padding: "6px 12px",
                  borderRadius: 20,
                  fontSize: 13,
                  fontWeight: 500,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
              >
                {area}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Close Button */}
      <div style={{ textAlign: "center", marginTop: 25 }}>
        <button
          onClick={() => setShowModal(false)}
          style={{
            background: "var(--accent)",
            color: "#fff",
            padding: "10px 25px",
            borderRadius: 30,
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 15,
            boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--accent)")
          }
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}


if(activeComponent==='Divyangjan Volunteers'){
    return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between" ,  alignItems: "center",}}>
        <h2 style={{ color: "var(--primary)" }}>Divyangjan Volunteers</h2>
        <div style={{
  display: "flex",

  alignItems: "center",
  marginBottom: 1,
}}>

  {/* Search Bar */}
  <input
    type="text"
    placeholder="Search name, email, mobile, city, registration..."
    value={searchDiv}
    onChange={(e) => {
      setSearchDiv(e.target.value);
      setCurrentPageDiv(1); // reset pagination
    }}
    style={{
      padding: "10px 15px",
      width: "280px",
      borderRadius: 8,
      border: "1px solid #ccc",
      outline: "none"

    }}
  />

  {/* Download Excel */}
  <button
    onClick={downloadExcelDiv}
    style={{
      background: "#7B1E3A",
      color: "#fff",
      padding: "10px 18px",
      borderRadius: 8,
      cursor: "pointer",
      border: "none",
      fontWeight: 600,
        marginLeft: 10,
    }}
  >
    📥 Download Excel
  </button>

</div>

      </div>



      {/* Table */}
      <div style={{ overflowX: "auto", marginTop: 20 }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "800px",
            border: "1px solid #ddd",
          }}
        >
          <thead style={{ background: "var(--primary)", color: "#fff" }}>
            <tr>
              <th>#</th>
              <th>Profile</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Aadhaar</th>
              <th>City</th>
              <th>Status</th>
              <th>Actions</th>
               <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {currentItemsDiv.map((v, i) => (
              <tr key={v.id}>
                <td style={tdStyle}>{i + 1}</td>
                <td style={tdStyle}>
                  <img
                    src={v.profile_image}
                    alt="profile"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                </td>
                <td style={tdStyle}>{v.name}</td>
                <td style={tdStyle}>{v.email}</td>
                <td style={tdStyle}>{v.mobile}</td>
                <td style={tdStyle}>{maskAadhaar(v.aadhar_number)}</td>
                <td style={tdStyle}>{v.city}</td>
                 <td style={tdStyle}>
          {v.is_approved === 1 ? (
            <span
              style={{
                background: "linear-gradient(90deg, #28a745, #5cd68a)",
                color: "#fff",
                padding: "5px 12px",
                borderRadius: 20,
                fontSize: 13,
                fontWeight: 600,
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              Approved
            </span>
          ) : (
            <span
              style={{
                background: "linear-gradient(90deg, #ff9800, #ffc107)",
                color: "#fff",
                padding: "5px 12px",
                borderRadius: 20,
                fontSize: 13,
                fontWeight: 600,
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              Pending
            </span>
          )}
        </td>
                <td style={tdStyle}>
                  <button
                    onClick={() => {
                      setSelectedDivVolunteer(v);
                      setShowModalDiv(true);
                    }}
                    style={{
                      background: "var(--primary)",
                      color: "#fff",
                      marginRight: 6,
                      cursor: "pointer",
                      border: "none",
                      padding: "5px 10px",
                      borderRadius: 6,
                    }}
                  >
                    <FaEye />
                  </button>
<button
  onClick={() => handleApproveDiv(v.id)}
  disabled={v.is_approved === 1 || approvingId === v.id}
  style={{
    background: v.is_approved === 1 ? "#bbb" : "var(--accent)",
    color: "#fff",
    cursor:
      v.is_approved === 1
        ? "not-allowed"
        : approvingId === v.id
        ? "wait"
        : "pointer",
    border: "none",
    padding: "5px 10px",
    borderRadius: 6,
    opacity: v.is_approved === 1 ? 0.7 : 1,
    transition: "0.3s",
  }}
>
  {approvingId === v.id ? (
    <>
      <style>{spinKeyframes}</style>
      <span style={spinnerStyle}></span>
    </>
  ) : (
    <FaCheck />
  )}
</button>


                </td>
                  <td style={tdStyle}>
        <button
          onClick={() => handleDeleteDiv(v.id)}
          style={{
            background: "#e63946",
            color: "white",
            border: "none",
            padding: "5px 10px",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          <FaTrash />
        </button>
      </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 15,
          gap: 10,
        }}
      >
        {Array.from({ length: totalPagesDiv }).map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrentPageDiv(i + 1)}
            style={{
              padding: "6px 12px",
              background: currentPageV === i + 1 ? "var(--primary)" : "#eee",
              color: currentPageV === i + 1 ? "#fff" : "#333",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* Volunteer Detail Modal */}
 {showModalDiv && selectedDivVolunteer && (
  <div style={modalBackdrop}>
    <div style={modalBox}>
      {/* Header */}
      <div style={modalHeader}>
        <h3
          style={{
            margin: 0,
            color: "#fff",
            fontSize: 18,
            fontWeight: 600,
          }}
        >
          Volunteer Details
        </h3>
        <FaTimes
          style={{
            cursor: "pointer",
            color: "#fff",
            fontSize: 18,
          }}
          onClick={() => setShowModalDiv(false)}
        />
      </div>

   {/* Profile Section */}
<div
  style={{
    textAlign: "center",
    marginBottom: 20,
    marginTop: 10,
  }}
>
  <img
    src={selectedDivVolunteer.profile_image}
    alt={selectedDivVolunteer.name}
    style={{
      width: 100,
      height: 100,
      borderRadius: "50%",
      objectFit: "cover",
      border: "3px solid var(--accent)",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    }}
  />

  <h3
    style={{
      marginTop: 10,
      color: "var(--primary)",
      fontWeight: 700,
      fontSize: 20,
    }}
  >
    {selectedDivVolunteer.name}
  </h3>

  <p
    style={{
      marginTop: -5,
      color: "#ddb336ff",
      fontWeight: 600,
      fontSize: 14,
    }}
  >
    Reg No: {selectedDivVolunteer.divyangjan_enroll_id}
  </p>

  <p style={{ color: "#666", fontSize: 14 }}>
    {selectedDivVolunteer.city}, {selectedDivVolunteer.state}
  </p>
</div>


      {/* Info Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12,
          fontSize: 14,
          color: "#333",
        }}
      >
        <Info label="Email" value={selectedDivVolunteer.email} />
        <Info label="Mobile" value={selectedDivVolunteer.mobile} />
        <Info label="Country" value={selectedDivVolunteer.country} />
        <Info label="Aadhaar" value={selectedDivVolunteer.aadhar_number} />
   
       
        <Info label="Remarks" value={selectedDivVolunteer.remarks || "—"} />
      </div>

      {/* Interested Areas */}
      {selectedDivVolunteer.interested_areas && (
        <div
          style={{
            marginTop: 25,
            background: "#fafafa",
            padding: "15px 18px",
            borderRadius: 8,
            border: "1px solid #eee",
          }}
        >
          <h4
            style={{
              margin: "0 0 10px 0",
              fontSize: 15,
              fontWeight: 600,
              color: "var(--primary)",
            }}
          >
            Interested Areas
          </h4>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {interestedAreas.map((area, idx) => (
  <span
    key={idx}
    style={{
      background: "linear-gradient(135deg, #7B1E3A, #F2C94C)",
      color: "#fff",
      padding: "6px 12px",
      borderRadius: 20,
      fontSize: 13,
      fontWeight: 500,
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    }}
  >
    {area}
  </span>
))}

          </div>
        </div>
      )}

      {/* Close Button */}
      <div style={{ textAlign: "center", marginTop: 25 }}>
        <button
          onClick={() => setShowModalDiv(false)}
          style={{
            background: "var(--accent)",
            color: "#fff",
            padding: "10px 25px",
            borderRadius: 30,
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 15,
            boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
            transition: "0.3s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = "var(--primary)")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.background = "var(--accent)")
          }
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}

// if (activeComponent==="Media Page"){
//     return (
//     <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <h2 style={{ color: "var(--primary)" }}>Media</h2>

//         <button
//           onClick={() => {
//             setFormM({ platform: "", url: "" });
//             setEditingM(null);
//             setShowModalM(true);
//           }}
//           style={{
//             background: "var(--accent)",
//             color: "#fff",
//             border: "none",
//             padding: "8px 13px",
//             borderRadius: 6,
//             display: "flex",
//             alignItems: "center",
//             height: "40px",
//             cursor: "pointer",
//           }}
//         >
//           <FaPlus style={{ marginRight: 6 }} /> Add
//         </button>
//       </div>

//       {/* Table */}
//       <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
//         <thead style={{ background: "var(--primary)", color: "#fff" }}>
//           <tr>
//             <th>#</th>
//             <th>Platform</th>
//             <th>Preview</th>
//             <th>URL</th>
//             <th>Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {currentItemsM.map((item, i) => (
//             <tr key={item.id}>
//               <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
//                 {i + 1}
//               </td>
//               <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
//                 {item.platform.toUpperCase()}
//               </td>

//               <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
//                 {renderEmbed(item)}
//               </td>

//               <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
//                 <a href={item.url} target="_blank" rel="noreferrer">
//                   {item.url}
//                 </a>
//               </td>

//               <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
//                 <button
//                   onClick={() => handleEditM(item)}
//                   style={{
//                     background: "var(--primary)",
//                     color: "#fff",
//                     marginRight: 6,
//                     cursor: "pointer",
//                   }}
//                 >
//                   <FaEdit />
//                 </button>
//                 <button
//                   onClick={() => handleDeleteM(item.id)}
//                   style={{
//                     background: "var(--accent)",
//                     color: "#fff",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Modal */}
//       {showModalM && (
//         <div
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.4)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               background: "#fff",
//               borderRadius: 12,
//               width: "90%",
//               maxWidth: 420,
//               padding: "25px",
//             }}
//           >

//              <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginBottom: 20,
//                 borderBottom: "1px solid #eee",
//                 paddingBottom: 10,
//               }}
//             >
           

              
//             <h3 style={{ color: "var(--primary)" }}>
//               {editingM ? "Edit Media" : "Add Media"}
//             </h3>
// <FaTimes
//                 onClick={() => setShowModalM(false)}
//                 style={{ cursor: "pointer", fontSize: 18 }}
//               />
//             </div>
//             <form
//               onSubmit={handleSubmitM}
//               style={{ display: "flex", flexDirection: "column", gap: 15 }}
//             >
//               <label>Platform</label>
//               <select
//                 name="platform"
//                 value={formM.platform}
//                 onChange={handleChangeM}
//                 required
//                 style={{
//                   padding: 8,
//                   borderRadius: 6,
//                   border: "1px solid #ccc",
//                 }}
//               >
//                 <option value="">Select Platform</option>
//                 <option value="facebook">Facebook</option>
//                 <option value="instagram">Instagram</option>
//                 <option value="youtube">YouTube</option>
//               </select>

//               <label>Post/Video URL</label>
//               <input
//                 type="text"
//                 name="url"
//                 value={formM.url}
//                 onChange={handleChangeM}
//                 placeholder="Enter post URL"
//                 required
//                 style={{
//                   padding: 8,
//                   borderRadius: 6,
//                   border: "1px solid #ccc",
//                 }}
//               />

//               {/* Live Preview */}
//               {formM.url && (
//                 <div style={{ marginTop: 10, textAlign: "center" }}>
//                   {renderEmbed(formM)}
//                 </div>
//               )}

//               <button
//                 type="submit"
//                 style={{
//                   background: "var(--accent)",
//                   color: "#fff",
//                   padding: "10px 15px",
//                   borderRadius: 6,
//                   marginTop: 15,
//                   width: "100%",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   cursor: "pointer",
//                   border: "none",
//                   transition: "0.3s",
//                 }}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "var(--primary)")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "var(--accent)")
//                 }
//               >
//                 {editingM ? "Update" : "Add"}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Pagination */}
//       <div style={{ textAlign: "center", marginTop: 20 }}>
//         {Array.from({ length: totalPagesM }).map((_, i) => (
//           <button
//             key={i}
//             onClick={() => setCurrentPageM(i + 1)}
//             style={{
//               padding: "8px 12px",
//               margin: "0 4px",
//               borderRadius: 6,
//               background: currentPageM === i + 1 ? "var(--accent)" : "#ddd",
//               color: currentPageM === i + 1 ? "#fff" : "#333",
//               border: "none",
//               cursor: "pointer",
//             }}
//           >
//             {i + 1}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }


if (activeComponent === "VIPs") {
  return (
    <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
      <div style={{ display: "flex",   alignItems: "center", justifyContent: "space-between" }}>
        <h2 style={{ color: "var(--primary)" }}>VIP Members</h2>

        <div style={{
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

}}>
  
  <input
    type="text"
    placeholder="Search name or designation..."
    value={searchVIP}
    onChange={(e) => {
      setSearchVIP(e.target.value);
      setCurrentPageVIP(1); // reset page
    }}
    style={{
      padding: "10px 14px",
      width: "260px",
      borderRadius: 8,
      border: "1px solid #ccc",
      outline: "none"
    }}
  />

        <button
          onClick={() => {
            setFormVIP({ name: "", designation: "", photo: null });
            setEditingVIP(null);
            setShowVIPModal(true);
          }}
          style={{
             background: "var(--accent)",
            color: "#fff",
            border: "none",
            padding: "8px 13px",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            height: "40px",
            cursor: "pointer",
              marginLeft: 10
          }}
        >
          <FaPlus style={{ marginRight: 6 }} /> Add VIP
        </button>
      </div>
           </div>

      {/* TABLE */}

      
      <table style={{ width: "100%", marginTop: 20, border: "1px solid #ddd" }}>
        <thead style={{ background: "var(--primary)", color: "#fff" }}>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Designation</th>
            <th>Photo</th>
            <th>Certificate</th>
<th>ID Card</th>

            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItemsVIP.map((vip, i) => (
            <tr key={vip.id}>
              <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
                {i + 1}
              </td>

              <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
                {vip.name}
              </td>

              <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
                {vip.designation}
              </td>

              <td
                style={{
                  textAlign: "center",
                  border: "1px solid #ddd",
                  padding: "5px",
                }}
              >
                <img
                  src={vip.photo}
                  alt=""
                  style={{ width: 60, height: 60, borderRadius: 6 }}
                />
              </td>
<td style={{ textAlign: "center", border: "1px solid #ddd" }}>
  {!vip.certificate ? (
    <button
      onClick={() => generateCertificate(vip.id)}
      style={{
        background: "var(--primary)",
        color: "#fff",
        padding: "6px 10px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
      }}
    >
      Generate
    </button>
  ) : (
    <a
      href={vip.certificate}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        background: "green",
        color: "#fff",
        padding: "6px 10px",
        borderRadius: 6,
        textDecoration: "none",
      }}
    >
      Download
    </a>
  )}
</td>

<td style={{ textAlign: "center", border: "1px solid #ddd" }}>
  {!vip.id_card ? (
    <button
      onClick={() => generateIdCard(vip.id)}
      style={{
        background: "var(--primary)",
        color: "#fff",
        padding: "6px 10px",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
      }}
    >
      Generate ID
    </button>
  ) : (
    <a
      href={vip.id_card}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        background: "green",
        color: "#fff",
        padding: "6px 10px",
        borderRadius: 6,
        textDecoration: "none",
      }}
    >
      Download ID
    </a>
  )}
</td> 


              <td style={{ textAlign: "center", border: "1px solid #ddd" }}>
                <button
                  onClick={() => handleEditVIP(vip)}
                  style={{
                    background: "var(--primary)",
                    color: "#fff",
                    marginRight: 6,
                    cursor: "pointer",
                    border: "none",
                    padding: "6px 8px",
                  }}
                >
                  <FaEdit />
                </button>

                <button
                  onClick={() => deleteVIP(vip.id)}
                  style={{
                    background: "var(--accent)",
                    color: "#fff",
                    cursor: "pointer",
                    border: "none",
                    padding: "6px 8px",
                  }}
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

           {/* Pagination */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 15, gap: 10 }}>
        {Array.from({ length: totalPagesVIP }).map((_, i) => (
          <button
            key={i}
            onClick={() => handlePageChangeVIP(i + 1)}
            style={{
              padding: "6px 12px",
              background: currentPageVIP === i + 1 ? "#7B1E3A" : "#eee",
              color: currentPageVIP === i + 1 ? "#fff" : "#333",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            {i + 1}
          </button>
        ))}
      </div>

      {/* MODAL */}
      {showVIPModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 12,
              width: "90%",
              maxWidth: 420,
              padding: "25px 25px 30px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 20,
                borderBottom: "1px solid #eee",
                paddingBottom: 10,
              }}
            >
              <h3 style={{ margin: 0, fontSize: 18, color: "var(--primary)" }}>
                {editingVIP ? "Edit VIP" : "Add VIP"}
              </h3>

              <FaTimes
                onClick={() => setShowVIPModal(false)}
                style={{ cursor: "pointer", fontSize: 18 }}
              />
            </div>

            <form
              onSubmit={handleVIPSubmit}
              style={{ display: "flex", flexDirection: "column", gap: 15 }}
            >
              <label>Name</label>
              <input
                name="name"
                type="text"
                value={formVIP.name}
                onChange={handleVIPChange}
                required
                style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }}
              />

              <label>Designation</label>
              <input
                name="designation"
                type="text"
                value={formVIP.designation}
                onChange={handleVIPChange}
                required
                style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }}
              />

              <label>Photo</label>
              <input
                name="photo"
                type="file"
                accept="image/*"
                onChange={handleVIPChange}
                style={{ padding: 5 }}
              />
{formVIP.preview && (
  <img
    src={formVIP.preview}
    alt="Preview"
    style={{
      width: 70,
      height: 70,
      objectFit: "cover",
      borderRadius: 6,
      marginTop: 8,
      border: "1px solid #ccc",
    }}
  />
)}
              <button
                type="submit"
                style={{
                  background: "var(--accent)",
                  color: "#fff",
                  padding: "10px 15px",
                  borderRadius: 6,
                  marginTop: 15,
                  width: "100%",
                  fontWeight: 600,
                  fontSize: 15,
                  cursor: "pointer",
                  border: "none",
                  transition: "0.3s",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "var(--primary)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "var(--accent)")
                }
              >
                {editingVIP ? "Update VIP" : "Add VIP"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

if (activeComponent === 'Certificates & IDs'){
  return (
    <div style={{ padding: 25, background: "#fff", borderRadius: 12 }}>
      <div style={{ display: "flex", alignItems:'center' , justifyContent: "space-between" }}>
        <h2 style={{ color: "#7B1E3A" }}>Certificates & IDs</h2>
      <div style={{ position: "relative", width: "350px" }}>
        <input
          type="text"
          placeholder="Search by name, email, mobile, registration.."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            padding: "8px 10px 8px 35px", // Add space for the icon
            fontSize: "14px",
            borderRadius: "6px",
            border: "1px solid #ccc",  // Light gray border for a clean look
            width: "300px",
            height: "35px",
            marginTop: "5px",
            outline: "none",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)", // Light shadow for focus effect
          }}
        />
        <FaSearch
          style={{
            position: "absolute",
            left: "10px", // Adjust the position of the icon
            top: "50%",
            transform: "translateY(-50%)",
            color: "#7B1E3A", // Match the text color
            
          }}
        />
      </div>
      </div>

      {loadingCI ? (
        <div>Loading...</div>
      ) : (
     <div style={{ overflowX: "auto", marginTop: 20 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "800px", border: "1px solid #ddd" }}>
            <thead style={{ background: "#7B1E3A", color: "#fff" }}>
              <tr>
                <th>#</th>
                <th>Profile</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>City</th>
                <th>Reg ID</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItemsCI.map((user, index) => (
                <tr key={user.id}>
                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                    {startIndexCI + index + 1}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                    <img
                      src={user.profile_image}
                      alt="profile"
                      style={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center" }}>{user.name}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" , textAlign: "center"}}>{user.mobile}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" , textAlign: "center"}}>{user.city}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd" ,textAlign: "center"}}>{user.registration_no}</td>
                  <td style={{ padding: "8px", border: "1px solid #ddd", textAlign: "center"}}>
                    <button
                      onClick={() => downloadFileCI(user.certificate, "certificate")}
                      style={{
                        background: "#7b1e3a",
                        color: "#fff",
                        border: "none",
                        padding: "5px 10px",
                        marginRight: 6,
                        cursor: "pointer",
                        borderRadius: 6,
                      }}
                    >
                      <FaDownload /> Certificate
                    </button>
                    <button
                      onClick={() => downloadFileCI(user.id_card, "id")}
                      style={{
                        background: "#f2c94c",
                        color: "#fff",
                        border: "none",
                        padding: "5px 10px",
                        cursor: "pointer",
                        borderRadius: 6,
                      }}
                    >
                      <FaDownload /> ID
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}


      {/* Pagination */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 15, gap: 10 }}>
        {Array.from({ length: totalPagesCI }).map((_, i) => (
          <button
            key={i}
            onClick={() => handlePageChangeCI(i + 1)}
            style={{
              padding: "6px 12px",
              background: currentPageCI === i + 1 ? "#7B1E3A" : "#eee",
              color: currentPageCI === i + 1 ? "#fff" : "#333",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
}


    return (
      <div style={contentStyles.wrapper}>
        <h2 style={contentStyles.title}>Welcome, {adminEmail}</h2>
        <p style={{ color: "#555" }}>This is your admin dashboard home.</p>
      </div>
    );
  };

  return (
    <div style={baseStyles.container}>
      {/* Sidebar */}
      <div
        style={{
          ...baseStyles.sidebar,
          width: sidebarOpen ? "200px" : "70px",
        }}
      >
        <div style={baseStyles.logoArea}>
          {sidebarOpen ? (
            <div style={baseStyles.logoBlock}>
                  <span style={baseStyles.logoMain}>GARUDA</span>
    <span style={baseStyles.logoAccent}>SENA</span>
         
         
            </div>
          ) : (
            <span style={baseStyles.logoMain}>G</span>
          )}
        </div>

        <nav style={{ marginTop: "20px",maxHeight: "90vh", // adjust as needed
    overflowY: "auto", }}>
          {allNavItems.map((item) => (
            <div
              key={item.label}
              style={{
                ...baseStyles.navItem,
                backgroundColor:
                  activeComponent === item.label
                    ? "rgba(255,255,255,0.15)"
                    : "transparent",
                color:
                  activeComponent === item.label ? "var(--accent)" : "#fff",
              }}
              onClick={() => setActiveComponent(item.label)}
            >
              <div style={baseStyles.navIcon}>{item.icon}</div>
              {sidebarOpen && (
                <span style={baseStyles.navLabel}>{item.label}</span>
              )}
            </div>
          ))}
        </nav>
      </div>

      {/* Main Area */}
      <div style={baseStyles.mainArea(sidebarOpen)}>
        <div style={headerStyles.header}>
          <div style={headerStyles.leftGroup}>
            <button onClick={toggleSidebar} style={headerStyles.toggleBtn}>
              <FaBars color="#fff" />
            </button>
          </div>

          <div style={headerStyles.profileArea} ref={profileMenuRef}>
            <FaUserCircle
              size={30}
              style={{ cursor: "pointer", color: "var(--accent)" }}
              onClick={() => setShowProfileMenu((p) => !p)}
            />
            {showProfileMenu && (
              <div style={headerStyles.profileMenu}>
                <div
                  style={headerStyles.profileMenuItem}
                  onClick={handleLogout}
                >
                  <FaSignOutAlt style={{ marginRight: 8 }} /> Logout
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={baseStyles.contentWrapper}>{renderContent()}</div>
      </div>
    </div>
  );
};

export default AdminDashboard;

/* ---------- Styles ---------- */

const baseStyles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Segoe UI, sans-serif",
    background: "var(--bg-light)",
  },
  sidebar: {
    background: "linear-gradient(180deg, var(--primary) 0%, #132e55 100%)",
    color: "#fff",
    transition: "width 0.3s ease",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    padding: "15px 10px",
    boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  logoArea: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  logoBlock: { lineHeight: 1.2 },
  logoMain: {
    fontWeight: "800",
    color: "#fff",
    fontSize: "1.3rem",
    letterSpacing: "0.5px",
        marginRight: "12px",
  },
  logoAccent: {
    color: "var(--accent)",
    fontWeight: "700",
    fontSize: "1.1rem",
    marginLeft: "4px",
  },
  logoTagline: {
    fontSize: "0.7rem",
    color: "#c9d1d9",
    marginTop: "3px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 14px",
    marginBottom: "8px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  navIcon: { fontSize: "18px", marginRight: "10px" },
  navLabel: { fontSize: "15px", fontWeight: "500" },
  mainArea: (sidebarOpen) => ({
    marginLeft: sidebarOpen ? "220px" : "70px",
    transition: "margin-left 0.3s ease",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  contentWrapper: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
};

const headerStyles = {
  header: {
    height: "60px",
    background: "linear-gradient(90deg, var(--primary), #132e55)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
  },
  leftGroup: { display: "flex", alignItems: "center" },
  toggleBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
  },
  profileArea: { position: "relative" },
  profileMenu: {
    position: "absolute",
    right: 0,
    top: "calc(100% + 10px)",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  profileMenuItem: {
    padding: "10px 20px",
    cursor: "pointer",
    color: "var(--primary)",
    fontWeight: 500,
    borderBottom: "1px solid #eee",
  },
};

const contentStyles = {
  wrapper: {
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    padding: "25px",
  },
  title: {
    margin: 0,
    marginBottom: "20px",
    fontSize: "1.4rem",
    fontWeight: "700",
    color: "var(--primary)",
  },
  formRow: { display: "flex", gap: "10px", marginBottom: "20px" },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    flex: "0.3",
  },
  fileInput: {
    flex: "0.5",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  addBtn: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  thead: { background: "var(--primary)", color: "#fff" },
  th: {
    textAlign: "left",
    padding: "10px",
    fontWeight: "600",
  },
  td: { padding: "10px", borderBottom: "1px solid #eee" },
  btnEdit: {
    background: "var(--primary)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    marginRight: "6px",
    cursor: "pointer",
  },
  btnDelete: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
  },
  noData: { color: "#888", textAlign: "center", padding: "20px" },
};


// Common Styles
const tdStyle = {
  textAlign: "center",
  border: "1px solid #ddd",
  padding: "8px",
};

const modalBackdrop = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  backdropFilter: "blur(3px)",
};

const modalBox = {
  background: "#fff",
  borderRadius: 14,
  width: "90%",
  maxWidth: 520,
  padding: "25px 30px 35px",
  boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
  position: "relative",
  animation: "fadeIn 0.4s ease",
  overflowY: "auto",
  maxHeight: "90vh",
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "linear-gradient(90deg, #7B1E3A, #F2C94C)",
  padding: "12px 20px",
  borderRadius: "10px 10px 0 0",
};
